import { Action } from '@ngrx/store';
import {EventMonitoringFilter} from '../../../models/events';

export enum EventFiltersActionTypes {
  LoadEventFilterss = '[EventFilters] Load EventFilterss',
}

export class LoadEventFilterss implements Action {
  readonly type = EventFiltersActionTypes.LoadEventFilterss;
  constructor(public payload: EventMonitoringFilter) {}
}


export type EventFiltersActions = LoadEventFilterss;
